module.exports = __webpack_public_path__ + "static/media/desert1.23bee50b.png";